import { actionCreatorFactory } from 'typescript-fsa'

const actionCreator = actionCreatorFactory()

export const resetRootApp = actionCreator('resetRootApp')
